export enum EducationLevel {
    HIGH_SCHOOL = "HIGH_SCHOOL",
    BACHELOR = "BACHELOR",
    MASTER = "MASTER",
    PHD = "PHD",
    OTHER = "OTHER"
  }
  
  export enum Gender {
    MALE = "MALE",
    FEMALE = "FEMALE",
    OTHER = "OTHER"
  }
  
  export enum Occupation {
    SOFTWARE_ENGINEER = "SOFTWARE_ENGINEER",
    DESIGNER = "DESIGNER",
    DATA_SCIENTIST = "DATA_SCIENTIST",
    PRODUCT_MANAGER = "PRODUCT_MANAGER",
    MARKETING_SPECIALIST = "MARKETING_SPECIALIST"
  }
  